import React from "react";
import { Outlet } from "react-router-dom";

const RemoteMainFrame = (props) => {
  return (
    <div className='remoteMainFrame frame displayBlock padding10'>
      <Outlet />
    </div>
  );
};

export default RemoteMainFrame;
